<template>
  <footer id="main-footer">
    <div class="container -no-cf">
      <div class="box box-logo">
        <router-link class="logo" to="/">Fibra Experts</router-link>
      </div>

      <div class="box">
        <h5>Endereço</h5>

        <p>São Paulo</p>
        <p>Rua Alves Guimarães, 1120 - 2º andar</p>
        <p>Pinheiros - SP</p>
        <p>05410-002</p>
      </div>

      <div class="box box-contato">
        <h5>Contato</h5>

        <router-link to="/envio-mensagem">Fale com a<br /> FIBRA EXPERTS</router-link>
      </div>

      <div class="box">
        <h5>Outros acessos</h5>

        <a href="https://sac.fibraexperts.com.br" title="SAC">Portal do cliente</a>

        <a href="https://www.fibraexperts.com.br/files/politica-privacidade.pdf" target="_blank" title="Política de privacidade">Política de privacidade</a>

        <a title="Manual de conduta" href="https://fibraexperts.com.br/download/manual-de-compliance.pdf" target="_blank">Manual de conduta</a>

        <a title="Protocolo de Segurança Stand de Vendas" href="https://fibraexperts.com.br/download/FIB-0001-18DD_PROTOCOLO_DE_SEGURANCA_STAND_v5.pdf" target="_blank">Protocolo de Segurança<br />Stand de Vendas</a>
      </div>

      <div class="box box-redes">
        <h5>Redes sociais</h5>

        <a href="https://www.facebook.com/fibraexpertsoficial" target="_blank"><i class="icon -fb-blue"></i></a>

        <a href="https://www.linkedin.com/company/1607019/" target="_blank" title="LinkedIn Fibra"><i class="icon -ld-blue"></i></a>

        <a href="http://www.instagram.com/fibraexperts" target="_blank" title="Instagram Fibra"><i class="icon -ig-blue"></i></a>

        <a href="https://www.youtube.com/channel/UCYFaFSFAK5eMFV40h_IebBQ" target="_blank"><i class="icon -yt-blue"></i></a>
      </div>
    </div>
  </footer>
</template>

<script>
export default {}
</script>

<style lang="sass" scoped>
@import '@/assets/sass/_base.sass'

#main-footer
  margin-top: 15px
  padding-top: 50px
  padding-bottom: 40px
  font-family: 'Gotham-Light'
  background: #fff

  .container
    display: flex
    flex-direction: row
    align-items: flex-start
    justify-content: space-between

    > div:not(:last-of-type)
      border-right: 1px solid #E50019

  .box
    padding-right: 20px
    padding-left: 20px
    height: 225px

    h5
      font-family: 'Gotham-Bold'
      color: #5B8991
      font-size: 22px
      text-transform: uppercase
      margin-bottom: 10px
      display: block
      white-space: nowrap

    button
      color: #5B8991
      border: none
      background: none
      padding: 9px 0 0 0
      margin: -9px 0 0 0
      white-space: nowrap
      cursor: pointer
      font-size: 16px
      line-height: 20px
      text-align: left

    p,
    a:not(.logo)
      color: #5B8991
      font-size: 16px
      line-height: 22px
      display: block

    a
      margin-bottom: 15px

  .box-contato
    min-width: 180px

  .box-logo
    min-width: 300px
    padding-left: 0

    .logo
      width: 100%
      height: 47px
      display: block
      text-indent: -9999px
      background:
        image: url(/images/logo-blue.png)
        repeat: no-repeat
        size: contain
        position: center

  .box.box-redes
    padding-right: 0

    a
      line-height: 0

@media (max-width: 1050px)
  #main-footer
    padding-top: 0

    .privacy-policy-link
      text-align: right
      font-weight: 600
      display: block
      font-size: 14px

      &:hover
        text-decoration: underline

    .container
      flex-direction: column

      > div:not(:last-of-type)
        border-right: none
        border-bottom: 1px solid #E50019

      .box
        padding: 15px
        height: auto
        width: 100%

        &.box-logo
          min-width: initial

        &.box-redes
          display: flex
          flex-wrap: wrap

          a
            margin-right: 15px

            i.-yt-blue
              position: relative
              top: 5px

        h5
          font-size: 20px
          width: 100%
</style>
